import React, { useState, useEffect } from 'react';
import MultiListAsExceptionPopUp from '../atoms/MultiListAsExceptionPopUp';
function FromMoveAsExceptionList(props) {
  const [loading, setLoading] = useState(false);  // loader state here
  const handleClose = () => {
    props.setShowPopUpExAs(false);
    window.location.reload();  // Refresh page on close
  };
  return (
    <div className="row form-fields">
      <div className="label col-6" >
        <label>  </label>
      </div>
      <div className="item col-6" >
        <button onClick={() => { props.setShowPopUpExAs(true); }} className="btn btn-primary mb-2">
          &nbsp; Process &nbsp;<span className="bi bi-gear-fill"></span>
        </button>

        <MultiListAsExceptionPopUp
            titleExAs={props.labelExAs}
            showExAs={props.showPopUpExAs}
            showsetterExAs={handleClose}
            dataExAs={props.dataExAs}
            datasetterExAs={props.datasetterExAs}
            setLoadingAs={props.setLoadingAs}   // pass loader setter
            setProgress={props.setProgress}     // pass progress setter
            setTotal={props.setTotal}   // pass loader setter
        />
      </div>
    </div>
  )
}

export default FromMoveAsExceptionList